var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5424_3950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 15.6667V11.75C27.4167 10.7113 27.004 9.71506 26.2695 8.98054C25.535 8.24602 24.5388 7.83337 23.5 7.83337H9.79167C8.7529 7.83337 7.75668 8.24602 7.02216 8.98054C6.28765 9.71506 5.875 10.7113 5.875 11.75V35.25C5.875 36.2888 6.28765 37.285 7.02216 38.0195C7.75668 38.7541 8.7529 39.1667 9.79167 39.1667H23.5C24.5388 39.1667 25.535 38.7541 26.2695 38.0195C27.004 37.285 27.4167 36.2888 27.4167 35.25V31.3334",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1249 23.5L35.2499 17.625M41.1249 23.5L35.2499 29.375M41.1249 23.5H13.2847",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5424_3950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.b74050f615dd16757a491ce8b3e665e5.svg";
export { ForwardRef as ReactComponent };